export default __webpack_public_path__ + "static/media/Badges_Green.de90ac76.webp";